var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAwaitingTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.23841 0.69418C3.39154 0.904744 3.34499 1.19958 3.13443 1.35272L1.40586 2.60986C1.1953 2.763 0.900458 2.71644 0.74732 2.50588C0.594182 2.29532 0.640736 2.00048 0.8513 1.84734L2.57987 0.5902C2.79043 0.437063 3.08527 0.483616 3.23841 0.69418ZM8.76158 0.69418C8.91472 0.483616 9.20956 0.437063 9.42012 0.5902L11.1487 1.84734C11.3593 2.00048 11.4058 2.29532 11.2527 2.50588C11.0995 2.71644 10.8047 2.763 10.5941 2.60986L8.86556 1.35272C8.655 1.19958 8.60844 0.904744 8.76158 0.69418ZM5.99999 2.70003C3.83031 2.70003 2.07143 4.4589 2.07143 6.62859C2.07143 8.79827 3.83031 10.5571 5.99999 10.5571C8.16968 10.5571 9.92855 8.79827 9.92855 6.62859C9.92855 4.4589 8.16968 2.70003 5.99999 2.70003ZM1.12858 6.62859C1.12858 3.93818 3.30959 1.75717 5.99999 1.75717C8.6904 1.75717 10.8714 3.93818 10.8714 6.62859C10.8714 9.31899 8.6904 11.5 5.99999 11.5C3.30959 11.5 1.12858 9.31899 1.12858 6.62859ZM5.99999 4.27145C6.26036 4.27145 6.47142 4.48252 6.47142 4.74288V6.15716H7.25713C7.51749 6.15716 7.72856 6.36822 7.72856 6.62859C7.72856 6.88895 7.51749 7.10001 7.25713 7.10001H5.99999C5.73963 7.10001 5.52857 6.88895 5.52857 6.62859V4.74288C5.52857 4.48252 5.73963 4.27145 5.99999 4.27145Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwaitingTag);
export default __webpack_public_path__ + "static/media/awaiting_tag.a4b12b345c16d3715f670eca58dfbb76.svg";
export { ForwardRef as ReactComponent };